<!-- Spacer -->
<div class="servicemesh-vertical-navigation-item-wrapper" [ngClass]="item.classes?.wrapper"></div>
